import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import { getMessageActions } from "./actions.js";
class MessageReducerCreator {
  _messageActions;
  constructor() {
    this._messageActions = getMessageActions();
  }
  createReducer() {
    return combineReducers({
      message: this.createMessageReducer(),
      values: this.createValuesReducer(),
      mode: this.createModeReducer()
    });
  }
  createMessageReducer() {
    return createReducer(null).handleAction(this._messageActions.saveMessage, (state, action) => action.payload?.message ?? state).handleAction(this._messageActions.clearMessage, () => null);
  }
  createValuesReducer() {
    return createReducer(null).handleAction(this._messageActions.saveMessage, (state, action) => action.payload?.values ?? state).handleAction(this._messageActions.clearMessage, () => null);
  }
  createModeReducer() {
    return createReducer("success").handleAction(
      this._messageActions.saveMessage,
      (state, action) => action.payload?.mode ?? state
    );
  }
}
export {
  MessageReducerCreator
};
//# sourceMappingURL=reducers.js.map
